// auth.service.ts (consider renaming to state.service.ts)
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiServiceService } from './api-service.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  // User authentication state
  private userSubject = new BehaviorSubject<any>(null);
  currentUser$ = this.userSubject.asObservable();

  // Cart state
  private cartSubject = new BehaviorSubject<any[]>([]);
  currentCart$ = this.cartSubject.asObservable();
  totalProducts: number = 0;
  // Track initialization status
  private isInitialized = false;

  private closeMenuSubject = new Subject<void>();

  // Observable to listen for close menu events
  closeMenu$ = this.closeMenuSubject.asObservable();

  constructor(private api: ApiServiceService) {}

  // Initialize both user and cart on app start (only once when token exists)
  initialize() {
    // Skip if already initialized
    if (this.isInitialized) {
      return;
    }

    const token = localStorage.getItem('token');
    if (token) {
      this.fetchUserData();
      this.fetchCartData();
      this.isInitialized = true; // Mark as initialized
    }
  }

  // User methods
  private fetchUserData() {
    this.api.getUserByToken().subscribe({
      next: (res) => this.userSubject.next(res.data),
      error: () => this.clearUser(),
    });
  }

  setUser(user: any, token: string) {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', JSON.stringify(user.id));
    this.userSubject.next(user);
    this.fetchCartData(); // Get cart when user logs in
    this.isInitialized = true; // Mark as initialized after successful login
  }

  clearUser() {
    localStorage.clear();
    this.userSubject.next(null);
    this.cartSubject.next([]); // Clear cart when user logs out
    this.totalProducts = 0;
    this.isInitialized = false; // Reset initialization flag on logout
  }

  // Cart methods
  private fetchCartData() {
    const userId = this.getCurrentUserId();
    if (userId) {
      this.api.getCartList(userId).subscribe({
        next: (data) => {
          this.cartSubject.next(data.data);
          this.totalProducts = data.data?.length || 0;
        },
        error: () => {
          this.cartSubject.next([]);
          this.totalProducts = 0;
        },
      });
    }
  }

  updateCart(cartItems: any[]) {
    this.cartSubject.next(cartItems);
    this.totalProducts = cartItems?.length || 0;
  }

  // Helper methods
  getCurrentUserId(): string {
    const user = this.userSubject.value;
    return user?.id || '';
  }

  triggerCartUpdate() {
    this.fetchCartData();
  }

  // Method to notify when the menu should be closed
  closeSideMenu() {
    this.closeMenuSubject.next();
  }
}
